import React from 'react';
import {Card, makeStyles} from '@rneui/themed';

import {Day} from '../../../transport/apiServiceResponse';
import Text from '../../themed/Text';
import PressableWithOpacityFeedback from '../../ui-controls/PressableWithOpacityFeedback';
import {View} from 'react-native';

type DayTileProps = {
  onPress: (item: Day) => void;
  item: Day;
  selected: boolean;
};

function DayTile({onPress, item, selected}: DayTileProps) {
  const todayString = new Date().toLocaleDateString();
  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);
  const tomorrowString = tomorrow.toLocaleDateString();

  const styles = useStyles({selected});
  const day = new Date(item);
  const itemLocale = day.toLocaleDateString();
  let topString = day.toLocaleDateString('en-AU', {weekday: 'short'});
  let bottomString = day.toLocaleDateString('en-AU', {
    month: 'short',
    day: 'numeric',
  });

  switch (itemLocale) {
    case todayString:
      topString = 'TODAY';
      break;
    case tomorrowString:
      topString = 'TOMORROW';
      break;
  }
  return (
    <PressableWithOpacityFeedback onPress={() => onPress(item)}>
      <Card
        noMargin
        variant="button"
        radius="rounded-md"
        containerStyle={styles.containerStyle}
        wrapperStyle={styles.wrapperStyle}>
        <Text style={styles.topText} variant="caption">
          {topString.toLocaleUpperCase()}
        </Text>
        <Text style={styles.bottomText} variant="caption">
          {bottomString}
        </Text>
      </Card>
    </PressableWithOpacityFeedback>
  );
}

type TimeTileProps = {
  onPress: (item: any) => void;
  item: any;
  selected: boolean;
};

function TimeTile({onPress, item, selected}: TimeTileProps) {
  const styles = useStyles({selected});
  let [from, to] = [
    new Date(item.dropOffWindow[0]),
    new Date(item.dropOffWindow[1]),
  ].map(time => time.toLocaleString('en-AU', {timeStyle: 'short'}));

  return (
    <PressableWithOpacityFeedback
      /**
       * Formik needs custom event if want to put object
       */
      onPress={() => onPress(item)}
      style={{
        flex: 1 / 3,
        marginLeft: 13,
        marginRight: 13,
        marginTop: 15,
      }}>
      <Card
        noMargin
        variant="button"
        radius="rounded-md"
        containerStyle={styles.timeTileContainerStyle}
        wrapperStyle={styles.wrapperStyle}>
        <Text style={styles.bottomText} variant="caption">
          {from}
        </Text>
      </Card>
    </PressableWithOpacityFeedback>
  );
}

export const TimeTileSpacer = () => {
  return (
    <View
      style={{flex: 1 / 3, marginLeft: 13, marginRight: 13, marginTop: 15}}
    />
  );
};

const useStyles = makeStyles((theme, {selected}: any) => {
  return {
    containerStyle: {
      width: 90,
      height: 68,
      paddingLeft: 0,
      paddingRight: 0,
      marginBottom: 3,
      ...(selected
        ? {backgroundColor: theme.colors.backgroundColorSelected}
        : {}),
    },
    timeTileContainerStyle: {
      height: 37,
      padding: 0,
      marginBottom: 3,
      ...(selected
        ? {backgroundColor: theme.colors.backgroundColorSelected}
        : {}),
    },
    wrapperStyle: {
      padding: 0,
      alignItems: 'center',
      justifyContent: 'center',
      gap: 4,
      flexGrow: 1,
    },
    topText: {
      fontSize: 12,
      fontWeight: '600',
      color: theme.colors.grey0,
    },
    bottomText: {
      fontSize: 14,
      fontWeight: '600',
      color: theme.colors.grey0,
    },
    containerStyleSelected: {
      backgroundColor: theme.colors.primary,
    },
  };
});

export default DayTile;

export {TimeTile};
